var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"step-two"},[_c('register-form-step-two',{attrs:{"emails":_vm.emailsList},on:{"send":_vm.sendRegister}}),_c('help-button',{on:{"help":_vm.goToHelp}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }